export const extractKey = (key: string, separator: string = ":") => {
  const [_, id] = key.split(separator);
  return +id;
};
